import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const currentUserPermissionsRequest = createAction(
  types.CURRENT_USER_PERMISSIONS_REQUEST,
);
export const currentUserPermissionsSuccess = createAction(
  types.CURRENT_USER_PERMISSIONS_SUCCESS,
);
export const currentUserPermissionsFailure = createAction(
  types.CURRENT_USER_PERMISSIONS_FAILURE,
);

export const userRolesRequest = createAction(types.USER_ROLES_REQUEST);
export const userRolesSuccess = createAction(types.USER_ROLES_SUCCESS);
export const userRolesFailure = createAction(types.USER_ROLES_FAILURE);

export default {
  currentUserPermissionsRequest,
  currentUserPermissionsSuccess,
  currentUserPermissionsFailure,
  userRolesRequest,
  userRolesSuccess,
  userRolesFailure,
};
